import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8cd66eb0&scoped=true&lang=html&"
import script from "./customSingularDetail.js?vue&type=script&lang=js&"
export * from "./customSingularDetail.js?vue&type=script&lang=js&"
import style0 from "./customSingularDetail.styl?vue&type=style&index=0&id=8cd66eb0&lang=stylus&scoped=true&"
import style1 from "./resetStyle.styl?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd66eb0",
  null
  
)

export default component.exports